import LoadingMessage from "./LoadingMessage";

export default LoadingMessage;
